import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as partnerActions from '../../actions/partnerActions';
import utils from '../../lib/utils';

export class PartnerSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      partnerSFID: null,
      optionFound: false,
      label: "",
      partnerID: null,
      value: ""
    };
  }

  componentDidMount() {
    this.fetchPartnersAndMaybeSetVal();
  }

  async fetchPartnersAndMaybeSetVal() {
    await this.props.actions.fetchPartners();
    let paramID = this.props.params.split('pid=')[1];
    if (paramID !== undefined) {
      paramID = paramID.split("&")[0];
    }
    this.setState({
      partnerSFID: paramID,
      optionFound: false
    });
    if (paramID !== null) {
      this.setPartnerBySFID(paramID);
    }
  }

  changeValue(e) {
    const id = parseInt(e.target.value, 10);
    const option = this.props.partnerOptions.find(option => option.value === id);
    this.setState({value: e.target.value});
    this.props.actions.selectPartner({
      partner_id: option.value,
      partner_uuid: option.uuid
    });
  }

  setPartnerBySFID(id) {
    let option;
    if (this.props.partnerOptions.length > 0) {
      option = this.props.partnerOptions.find(option => option.salesforce_id === id);
    }
    if (option !== undefined) {
      this.props.actions.selectPartner({
        partner_id: option.value,
        partner_uuid: option.uuid
      });
      this.setState({
        label: option.label,
        optionFound: true,
        partnerID: option.value
      });
    }
  }

  render() {
    const { partnerOptions } = this.props;
    const mapOptions = utils.mapDropdownOptions(
      partnerOptions,
      "partner-option"
    );
    if (partnerOptions.length > 0 && !this.state.optionFound) {
      return(
        utils.renderSelect(
          mapOptions,
          "header__partner-selector",
          this.changeValue.bind(this),
          " - Select a Partner - ",
          this.state.value
        )
      );
    } else if (partnerOptions.length > 0) {
      const label = this.state.label;
      return (
        <select
          onChange={this.changeValue.bind(this)}
          className="select"
        >
          <option value={this.state.partnerID}>{label}</option>
          <option value=""> ------------------------ </option>
          {
            mapOptions
          }
        </select>
      );
    }else{
      return null;
    }
  }
}

PartnerSelector.propTypes = {
  actions: PropTypes.object,
  partnerOptions: PropTypes.array,
  selectedPartner: PropTypes.object,
  params: PropTypes.string
};

PartnerSelector.defaultProps = {
  params: ""
};

function mapStateToProps(state) {
  return {
    partnerOptions: state.partner.options,
    selectedPartner: state.partner.selected
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(partnerActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnerSelector);
